module.exports = __webpack_public_path__ + "img/mainFunction-icon3.d7e06a64.png";